import { makeStyles } from "@fluentui/react-components";
import designTokens from "theme/customTheme";

export const useManageCategoriesStyles = makeStyles({
  titleText: {
    fontWeight: designTokens.fontWeight.medium,
    color: designTokens.neutral[900],
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    display: "block",
  },

  descriptionText: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },

  tagsCell: {
    display: "flex",
    alignItems: "center",
    gap: designTokens.spacing[2],
    flexWrap: "nowrap",
    overflow: "hidden",
    cursor: "pointer",
  },

  moreText: {
    fontSize: designTokens.fontSize.xs,
    color: designTokens.neutral[500],
    fontWeight: designTokens.fontWeight.medium,
    whiteSpace: "nowrap",
  },

  tooltipContent: {
    whiteSpace: "pre-line",
  },
});
